import { render, staticRenderFns } from "./OkvedsDialog.vue?vue&type=template&id=4779a4cb&"
import script from "./OkvedsDialog.vue?vue&type=script&lang=js&"
export * from "./OkvedsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports